import { FETCH_VEHICLE_MODEL, GET_VEHICLE_MODEL, CREATE_VEHICLE_MODEL, UPDATE_VEHICLE_MODEL, DELETE_VEHICLE_MODEL } from 'actions/vehicleModel';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  vehicleModels: [],
  vehicleModelDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const vehicleModelReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_VEHICLE_MODEL.REQUEST:
    case GET_VEHICLE_MODEL.REQUEST:
    case CREATE_VEHICLE_MODEL.REQUEST:
    case DELETE_VEHICLE_MODEL.REQUEST: {
      return { ...state, isLoading: true, vehicleModelDetail: {} };
    }

    case UPDATE_VEHICLE_MODEL.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_VEHICLE_MODEL.SUCCESS: {
      if (payload.page === 1) {
        return {
          ...state,
          isLoading: false,
          vehicleModels: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          vehicleModels: _.concat(state.vehicleModels, payload.results),
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      }
    }

    case GET_VEHICLE_MODEL.SUCCESS: {
      return {
        ...state,
        vehicleModelDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_VEHICLE_MODEL.SUCCESS: {
      toast.success('EV model added successfully');
      return {
        ...state,
        vehicleModels: _.concat(state.vehicleModels, payload),
        isLoading: false,
      };
    }

    case UPDATE_VEHICLE_MODEL.SUCCESS: {
      toast.success('EV model updated successfully');
      return {
        ...state,
        vehicleModels: state.vehicleModels.map((data) => (data.id === payload.id ? payload : data)),
        isLoading: false,
      };
    }

    case DELETE_VEHICLE_MODEL.SUCCESS: {
      toast.success('EV model deleted successfully');
      return {
        ...state,
        isLoading: false,
        vehicleModels: state.vehicleModels.filter((data) => data.id !== payload),
      };
    }

    case FETCH_VEHICLE_MODEL.FAIL:
    case GET_VEHICLE_MODEL.FAIL:
    case CREATE_VEHICLE_MODEL.FAIL:
    case UPDATE_VEHICLE_MODEL.FAIL:
    case DELETE_VEHICLE_MODEL.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
export default vehicleModelReducer;
